import { render, staticRenderFns } from "./BaViewHoldingListModal.vue?vue&type=template&id=54028722&scoped=true&"
import script from "./BaViewHoldingListModal.vue?vue&type=script&lang=js&"
export * from "./BaViewHoldingListModal.vue?vue&type=script&lang=js&"
import style0 from "./BaViewHoldingListModal.vue?vue&type=style&index=0&id=54028722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54028722",
  null
  
)

export default component.exports